import { Badge } from '@/ui/components'
import { Sparkles } from '@/ui/icons'
import { cn } from '@/shared/utils'

interface ProBadgeProps {
  className?: string
}

export function ProBadge({ className }: ProBadgeProps) {
  return (
    <Badge className={cn('gap-1 border-transparent bg-adventure-600 text-white hover:bg-adventure-600', className)}>
      <Sparkles className="h-3 w-3" />
      Pro
    </Badge>
  )
}
